export default "__VITE_ASSET__CGx_CpIA__"